/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(3);
	
	__webpack_require__(9);
	
	__webpack_require__(13);
	
	var _anchor = __webpack_require__(1);
	
	var _anchor2 = _interopRequireDefault(_anchor);
	
	__webpack_require__(4);
	
	__webpack_require__(6);
	
	var _share = __webpack_require__(15);
	
	var _share2 = _interopRequireDefault(_share);
	
	__webpack_require__(12);
	
	__webpack_require__(2);
	
	__webpack_require__(5);
	
	__webpack_require__(14);
	
	__webpack_require__(17);
	
	__webpack_require__(19);
	
	__webpack_require__(10);
	
	__webpack_require__(11);
	
	__webpack_require__(20);
	
	__webpack_require__(8);
	
	var _util = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$("body").addClass('_ready');
	// if ($('#promo')) {
	//     $('#promo').imagesLoaded( { background: true }, function() {
	//         $("body").addClass('_ready');
	//     });
	// } else {
	//     $("body").addClass('_ready');
	// }
	
	// подключаем svg для ie 11
	svg4everybody();
	
	// animate.css эффекты
	new WOW().init();
	
	if (!$('html').is('.mobile') && !$('html').is('.tablet')) {
	    $(".button").hover3d({
	        selector: "> i",
	        perspective: 100
	    });
	
	    $(".vacancies__item").hover3d({
	        selector: ".vacancies__card"
	    });
	
	    $(".projects-slider__nav").hover3d({
	        selector: ".projects-slider__nav-wrap",
	        perspective: 70
	    });
	
	    if (window.navigator.userAgent.indexOf("MSIE ") > 0 || window.navigator.userAgent.indexOf("Edge") > 0) {} else {
	        $('.vacancies__item').on("mousemove", function (e) {
	            var ax = -($(this).innerWidth() / 2 - e.offsetX) / 20;
	            var ay = ($(this).innerHeight() / 2 - e.offsetY) / 10;
	            $(this).find('.vacancies__card-img-pattern').attr("style", "transform: translate(" + ax / 10 + "%," + ay / 10 + "%)");
	            //$(this).find('.vacancies__card-img img:nth-child(2)').attr("style", "transform: scale(1.1) translate("+ax/10+"%,"+ay/10+"%)");
	            //$(this).find('.vacancies__card-img-bg').css("background-position", (50 - ax) + "% " + (50 - ay) + "%");
	        }).on("mouseout", function (e) {
	            $(this).find('.vacancies__card-img-pattern').attr("style", "");
	            //$(this).find('.vacancies__card-img img:nth-child(2)').attr("style", "");
	            //$(this).find('.vacancies__card-img-bg').css("background-position", "50% 50%");
	        });
	    }
	
	    $('.js-share').hover3d({
	        selector: "> i",
	        perspective: 10
	    });
	
	    $('.js-vacancy-citation-image').hover3d({
	        selector: "> img",
	        perspective: 200,
	        sensitivity: 100
	    });
	}
	
	//$('[style*="background-image:"]').imagesLoaded( { background: true }, function() {
	//    console.log('#container background image loaded');
	//});
	
	
	// шэрилки
	$('.js-share').click(function (e) {
	    e.preventDefault();
	    _share2.default[$(this).data('share')]();
	});
	
	// обработка меню
	var $toggler = $('.js-menu-toggler');
	$toggler.on('click', function () {
	    $('html').toggleClass('menu-opened', $(this).find('input').prop('checked'));
	});
	
	$('.menu__links').on('click', 'a', function () {
	    $('.js-menu-toggler input').prop('checked', false);
	    $('html').toggleClass('menu-opened', $('.js-menu-toggler input').prop('checked'));
	});
	
	// темизация меню в зависимости от блока под ним
	function sectionVisible(elem) {
	    var coords = elem.getBoundingClientRect();
	
	    //let windowHeight = document.documentElement.clientHeight;
	    // верхняя граница elem в пределах видимости ИЛИ нижняя граница видима
	    //let topVisible = coords.top > 0 && coords.top < windowHeight;
	    //let bottomVisible = coords.bottom < windowHeight && coords.bottom > 0;
	    //return topVisible || bottomVisible;
	
	    var val = coords.height + coords.top;
	    return val >= 60 && val <= coords.height + 60;
	}
	function menuTheme() {
	    //let sections = document.querySelectorAll('.js-section');
	    var sections = document.querySelectorAll('[data-menu]');
	    for (var i = sections.length - 1; i >= 0; i--) {
	        if (sectionVisible(sections[i])) {
	            //$('.js-header').toggleClass('_top', i == 0);
	            $('.js-header').attr('data-theme', $(sections[i]).data('menu'));
	            break;
	        }
	    }
	    //$('.js-header').toggleClass('_fixed', $(window).scrollTop() >= 100);
	    $('.js-header').toggleClass('_top', $(window).scrollTop() < 50);
	}
	$(window).on('scroll', function () {
	    menuTheme();
	});
	menuTheme();
	
	$('.js-logo').click(function (e) {
	    if ($('.js-header').is('._top') && $(e.currentTarget).is('[data-redirect]')) {
	        e.preventDefault();
	        window.location.href = $(e.currentTarget).data('redirect');
	    } else {
	        (0, _anchor2.default)(e);
	    }
	});
	
	// отложенная загрузка картинок после загрузки картинок в html
	$('body').imagesLoaded({ background: true }, function () {
	    $('img[data-src]').each(function () {
	        // для блока "гордимся пректами" заменяем катринки для вертикально ориентированного планшета
	        if ($(this).is('[data-src-tablet]') && device.tablet() && device.portrait()) {
	            $(this).attr('src', $(this).data('src-tablet'));
	        } else {
	            $(this).attr('src', $(this).data('src'));
	        }
	    });
	});
	
	// для блока "гордимся пректами" заменяем катринки для вертикально ориентированного планшета
	$(window).on('orientation:portrait', function () {
	    $('img[data-src]').each(function () {
	        $(this).attr('src', $(this).data('src-tablet'));
	    });
	});
	$(window).on('orientation:landscape', function () {
	    $('img[data-src]').each(function () {
	        $(this).attr('src', $(this).data('src'));
	    });
	});
	
	// загружаем рандомную картинку 404
	$('.js-page-404-image').each(function () {
	    var $img = $(this);
	    var imgUrls = $img.data('src-random').split(',');
	    var index = (0, _util.randomInteger)(0, imgUrls.length - 1);
	
	    this.src = imgUrls[index];
	
	    window.onload = function () {
	        $img.addClass('page-404-image-' + index);
	    };
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = anchorClick;
	$('.js-anchor').click(anchorClick);
	
	function scrollToAnchor(anchor, duration) {
	    scrollToOffset(anchor == '#top' ? 0 : $(anchor).length ? $(anchor)[0].offsetTop : 0, duration);
	}
	
	function scrollToOffset(top, duration) {
	    $('HTML,BODY').stop().animate({ scrollTop: top }, duration);
	}
	
	function anchorClick(e) {
	    var el = e.currentTarget;
	    if ($($(el).prop('hash')).length || $(el).prop('hash') == '#top' || $(el).data('anchor')) {
	        var hash = $(el).prop('hash') || $(el).data('anchor');
	
	        $(el).data('anchor') || e.preventDefault();
	        if ($(el).data('anchor-delay') != undefined) {
	            setTimeout(function () {
	                scrollToAnchor(hash, $(el).data('anchor-duration') != undefined ? $(el).data('anchor-duration') * 1000 : 1000);
	            }, $(el).data('anchor-delay') * 1000);
	        } else {
	            scrollToAnchor(hash, 1000);
	        }
	    }
	}

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Animate = function () {
	    function Animate() {
	        _classCallCheck(this, Animate);
	
	        //this.root = $('.js-team-slider');
	
	        this.init();
	    }
	
	    _createClass(Animate, [{
	        key: 'init',
	        value: function init() {
	            // ************** main page **************
	            // promo
	            $('.promo__heading,' + '.promo__info,' + '.promo__button-wrapper').addClass('_animated');
	
	            // ingame
	            $('.ingame__heading').addClass('wow fadeInUp').attr('data-wow-duration', '.75s').attr('data-wow-delay', '0s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.ingame__text').addClass('wow fadeInUp').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.2s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.ingame__info').addClass('wow fadeInUp').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.4s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            // facts
	            $('.facts__header').addClass('wow fadeInUp').attr('data-wow-duration', '.75s').attr('data-wow-delay', '0s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.facts__item:nth-of-type(1)').addClass('wow fadeInLeft').attr('data-wow-duration', '.75s').attr('data-wow-delay', '0s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.facts__item:nth-of-type(2)').addClass('wow fadeInRight').attr('data-wow-duration', '.75s').attr('data-wow-delay', '0s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.facts__item:nth-of-type(3)').addClass('wow fadeInLeft').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.25s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.facts__item:nth-of-type(4)').addClass('wow fadeInRight').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.25s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            // facts v2
	            $('.facts-v2-promo__header').addClass('wow fadeInUp').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.4s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.facts-v2-promo__person:nth-of-type(1)').addClass('wow fadeInLeft').attr('data-wow-duration', '.75s').attr('data-wow-delay', '1s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.facts-v2-promo__person:nth-of-type(2)').addClass('wow fadeInLeft').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.8s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.facts-v2-promo__person:nth-of-type(3)').addClass('wow fadeInLeft').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.6s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.facts-v2-promo__person:nth-of-type(4)').addClass('wow fadeInLeft').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.4s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            // leadership
	            $('.leadership__title').addClass('wow fadeInUp').attr('data-wow-duration', '.75s').attr('data-wow-delay', '0s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.leadership__text').addClass('wow fadeInUp').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.2s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.leadership__award:nth-of-type(1)').addClass('wow fadeIn').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.4s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.leadership__award:nth-of-type(2)').addClass('wow fadeIn').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.5s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.leadership__award:nth-of-type(3)').addClass('wow fadeIn').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.6s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.leadership__image').addClass('wow jackInTheBox').attr('data-wow-offset', '400').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.75s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.leadership__text-footer').addClass('wow fadeIn').attr('data-wow-duration', '.5s').attr('data-wow-delay', '.75s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            // projects
	            $('.js-projects-slider').addClass('_animated').attr('data-tolerance', '400').data('preRender', true);
	
	            // team
	            $('.js-team-slider').addClass('_animated').attr('data-tolerance', '300').data('preRender', true);
	
	            // vacancies
	            $('.vacancies__heading,' + '.vacancies__info,' + '.vacancies__request-title,' + '.vacancy-card-colored-block__title,' + '.vacancy-card-colored-block__text,' + '.vacancy-card-colored-block__footer').addClass('_animated');
	            $('.vacancies__item').addClass('_animated').each(function (i, el) {
	                $(el).css('transitionDelay', 0.4 + i * 0.2 + 's');
	            });
	
	            // photos
	            $('.photos__header,.photos__info').addClass('_animated');
	
	            // ************** vacancy page **************
	            // promo
	            $('.vacancy-promo__title,' + '.vacancy-promo__subtitle,' + '.vacancy-promo__desc,' + '.vacancy-promo__bg-hero img,' + '.vacancy-card__conditions li,' + '.vacancy-card__description-text,' + '.vacancy-card__option,' + '.vacancy-card__option-label,' + '.vacancy-card__option-text,' + '.vacancy-invitation__title,' + '.vacancy-invitation__button a,' + '.vacancy-invitation__share,' + '.vacancy-invitation__share .__tw').addClass('_animated');
	
	            // ************** vacancy manager page **************
	            // promo
	            $('.vacancy-citation,' + '.vacancy-description__shift-image,' + '.vacancy-description__cool,' + '.vacancy-description__wow,' + '.vacancy-manager-invitation__form .form').addClass('_animated');
	
	            //sections
	            $('.vacancy-description__heading').addClass('wow fadeInUp').attr('data-wow-duration', '.75s').attr('data-wow-delay', '0s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            $('.vacancy-description__text').addClass('wow fadeInUp').attr('data-wow-duration', '.75s').attr('data-wow-delay', '.4s').css('animation-timing-function', 'cubic-bezier(.33,1.02,.58,1)');
	
	            var onAnimate = function onAnimate() {
	                $('._animated:in-viewport').each(function (i, el) {
	                    // if ($(el).is('[data-tolerance]')) {
	                    //     $(el).filter(':in-viewport(' + $(el).data('tolerance') + ')').removeClass('_animated');
	                    // } else {
	                    //     $(el).filter(':in-viewport').removeClass('_animated');
	                    // }
	                    $(el).isInViewport({ tolerance: $(el).data('tolerance') || 0 }).each(function () {
	                        $(el).removeClass('_animated');
	                        if ($(el).is('.js-projects-slider')) {
	                            setTimeout(function () {
	                                $('.js-projects-slider').trigger('preRenderEnd');
	                            }, 0);
	                        } else if ($(el).is('.js-team-slider')) {
	                            setTimeout(function () {
	                                $('.js-team-slider').trigger('preRenderEnd');
	                            }, 0);
	                        }
	                    });
	                });
	            };
	            onAnimate();
	            $(window).on('scroll', onAnimate);
	        }
	    }]);
	
	    return Animate;
	}();
	
	var animate = device.mobile() || device.tablet() ? [] : new Animate();
	
	exports.default = animate;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	window.App = {
	    W: $(window),
	    D: $(document),
	    H: $('html'),
	    B: $('body')
	};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	// флаги готовности счетчиков
	let counters = {
	    ga: false,
	    ya: false
	};
	
	// прверка все ли счетчики загружены
	$(document).on('counter:ready', function (e, data) {
	    if (counters[data] != undefined) {
	        counters[data] = true;
	        for(let key in counters) {
	            if (counters[key] == false) {
	                return;
	            }
	        }
	        jQuery(document).trigger('counters:ready');
	    }
	});
	*/
	
	// запоминаем вызовы счетчика до его инициализации
	window.gaCounterQueue = [];
	window.gaCounter = function () {
	    window.gaCounterQueue.push([].slice.call(arguments));
	};
	
	$(document).on('ga:ready', function () {
	    var is_admin = window.is_admin;
	    var clientID = void 0;
	    var sessionID = void 0;
	
	    // Получаем переменную clientId из гугл-аналитики (https://ru.advertisercommunity.com/t5/Stati/4-sposoba-poluchit-cid-Client-ID-polzovatelya-Google-Analytics/ba-p/109199#)
	    ga(function (tracker) {
	        clientID = tracker.get('clientId');
	
	        // Получаем переменную sessionID
	        if (clientID) {
	            sessionID = clientID + '_' + new Date().getTime();
	            $(document).trigger('ga:clientID', clientID);
	        }
	
	        window.clientIdGA = clientID;
	        sendStatistic();
	
	        // Только после этого запускаем счётчик яндекса со своими параметрами
	        window.initYaCounter(document, window, 'yandex_metrika_callbacks', [clientID, sessionID]);
	    });
	
	    // Отправляем статистику
	    function sendStatistic() {
	        ga('send', 'pageview', {
	            'dimension1': 'traffic_by_admin_' + is_admin,
	            'dimension2': clientID,
	            'dimension3': sessionID
	        });
	    }
	
	    // выполняем сохраненные вызовы счетчика сделанные до инициализации
	    window.gaCounterQueue.forEach(function (arr) {
	        ga.apply(null, arr);
	    });
	    window.gaCounter = function () {
	        window.ga.apply(null, arguments);
	    };
	    delete window.gaCounterQueue;
	});
	
	// запоминаем вызовы счетчика до его инициализации
	window.yaCounter = {
	    queue: [],
	    reachGoal: function reachGoal() {
	        var arr = [].slice.call(arguments);
	        arr.unshift('reachGoal');
	        this.queue.push(arr);
	    }
	};
	
	// выполняем сохраненные вызовы счетчика сделанные до инициализации
	$(document).on('ya:ready', function (e, ya) {
	    requestAnimationFrame(function () {
	        window.yaCounter.queue.forEach(function (arr) {
	            var action = arr.shift();
	            ya[action].apply(null, arr);
	        });
	        window.yaCounter = ya;
	    });
	});
	
	// отправка целей по событиям
	$(document).on('counters:main_advantages_block_show', function () {
	    gaCounter("send", "event", "main_advantages_block", "show");
	    yaCounter.reachGoal("main_advantages_block_show");
	});
	
	$(document).on('counters:main_advantages_block_click', function () {
	    gaCounter("send", "event", "main_advantages_block", "click");
	    yaCounter.reachGoal("main_advantages_block_click");
	});
	
	$(document).on('counters:main_vacancies_block_show', function () {
	    gaCounter("send", "event", "main_vacancies_block", "show");
	    yaCounter.reachGoal("main_vacancies_block_show");
	});
	
	$(document).on('counters:main_vacancies_block_click', function (e, data) {
	    gaCounter("send", "event", "main_vacancies_block", "click", data);
	    yaCounter.reachGoal("main_vacancies_block_click");
	});

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Facts = function () {
	    function Facts() {
	        _classCallCheck(this, Facts);
	
	        this.root = $('.js-facts-slider');
	        if (!this.root.length) return;
	        this.slides = $('.js-facts-slider-item', this.root);
	        this.slidesBg = $('.js-facts-slider-bg', this.root);
	        this.bullets = $('.js-facts-slider-bullets', this.root);
	        this.next = $('.js-facts-slider-next', this.root);
	        this.prev = $('.js-facts-slider-prev', this.root);
	        this.promoButton = $('.js-promo-next', this.root);
	        this.mapLinks = $('.js-facts-promo-person', this.root);
	        this.currentSlide = this.slides.filter('._active').length ? this.slides.filter('._active') : this.slides.eq(0);
	        this.animating = false;
	        this.duration = 800;
	
	        this.init();
	    }
	
	    _createClass(Facts, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            this.root.addClass('_dir-prev');
	            this.currentSlide.next().addClass('_prev');
	
	            this.slides.each(function (i, el) {
	                _this.bullets.append('<i' + (i == _this.currentSlide.index() ? ' class="_active"' : '') + '>');
	                $(el).find('.js-facts-slider-number').text($(el).index() > 9 ? $(el).index() : '0' + $(el).index());
	                $(el).find('.js-facts-slider-total').text(_this.slides.length > 9 ? _this.slides.length - 1 : '0' + (_this.slides.length - 1));
	            });
	
	            if (this.root.data('preRender')) {
	                this.root.on('preRenderEnd', function () {
	                    _this.currentSlide.addClass('_active');
	                    _this.initFirstSlide();
	                    _this.bind();
	                });
	            } else {
	                this.currentSlide.addClass('_active');
	                this.initFirstSlide();
	                this.bind();
	            }
	        }
	    }, {
	        key: 'bind',
	        value: function bind() {
	            var _this2 = this;
	
	            if (device.mobile() || device.tablet()) {
	                this.root.hammer().on('swipeleft', function (ev) {
	                    _this2.next.click();
	                });
	
	                this.root.hammer().on('swiperight', function (ev) {
	                    _this2.prev.click();
	                });
	            }
	
	            this.mapLinks.on('click', function (e) {
	                e.preventDefault();
	                if (_this2.animating) return;
	                $(e.currentTarget).parent().addClass('__clicked');
	                setTimeout(function () {
	                    $(e.currentTarget).parent().removeClass('__clicked');
	                    _this2.slideTo(_this2.slides.eq($(e.currentTarget).data('person')));
	                    $(document).trigger('counters:main_advantages_block_click');
	                }, device.mobile() || device.tablet() ? _this2.duration : 0);
	            });
	
	            this.promoButton.on('click', function () {
	                _this2.slideTo(_this2.slides.eq(1));
	                $(document).trigger('counters:main_advantages_block_click');
	            });
	
	            this.next.on('click', function (e) {
	                _this2.slideTo(_this2.currentSlide.next().length ? _this2.currentSlide.next() : _this2.slides.eq(0));
	            });
	
	            this.prev.on('click', function (e) {
	                _this2.slideTo(_this2.currentSlide.prev().length ? _this2.currentSlide.prev() : _this2.slides.eq(_this2.slides.length - 1));
	            });
	
	            this.bullets.find('i').on('click', function (e) {
	                _this2.slideTo(_this2.slides.eq($(e.currentTarget).index()));
	            });
	
	            $(window).on('scroll', $.proxy(this.inViewport, this));
	        }
	    }, {
	        key: 'slideTo',
	        value: function slideTo(slide) {
	            var _this3 = this;
	
	            if (this.animating || this.currentSlide[0] == slide[0]) return;
	            this.animating = true;
	            this.root.removeClass('_dir-prev _dir-next');
	            this.slides.removeClass('_prev');
	            if (this.currentSlide.index() - slide.index() == this.slides.length - 1 || this.currentSlide.index() - slide.index() != -(this.slides.length - 1) && this.currentSlide.index() < slide.index()) {
	                this.root.addClass('_dir-next');
	            } else {
	                this.root.addClass('_dir-prev');
	            }
	            this.currentSlide.addClass('_leaving');
	            this.bullets.find('i').removeClass('_active').eq(slide.index()).addClass('_active');
	            this.root[0].offsetHeight; // задержка
	            this.root.addClass('_animating');
	
	            setTimeout(function () {
	                //this.animating = false;
	
	                _this3.currentSlide.removeClass('_active').addClass('_prev');
	                _this3.currentSlide = slide.addClass('_active');
	                _this3.root.attr('data-active', _this3.currentSlide.index());
	                // this.slidesBg.css({
	                //     color: this.currentSlide.data('colors').split(',')[0],
	                //     fill: this.currentSlide.data('colors').split(',')[1]
	                // });
	                // this.currentSlide.css({
	                //     fill: this.currentSlide.data('colors').split(',')[0]
	                // });
	                if (_this3.currentSlide.index() === 0) {
	                    _this3.currentSlide.find('._hover-map').removeClass('_hover-map');
	                    _this3.currentSlide.find('.facts-promo__content-item').eq(0).addClass('_hover-map');
	                }
	                _this3.root[0].offsetHeight; // задержка
	                _this3.slides.removeClass('_leaving');
	
	                setTimeout(function () {
	                    _this3.animating = false;
	                    _this3.root.removeClass('_animating');
	                }, _this3.duration);
	            }, this.duration / 2);
	        }
	    }, {
	        key: 'initFirstSlide',
	        value: function initFirstSlide() {
	            //let teamPromo = $('.js-facts-promo');
	            var creative = $('.js-facts-promo-creative');
	            var persons = $('.js-facts-promo-person');
	            var content = $('.js-facts-promo-content').children();
	
	            if (device.desktop()) {
	                $('.js-facts-promo-map area').hover(function () {
	                    if ($(this).closest('.js-facts-slider').hasClass('_animating')) return;
	                    content.eq(0).removeClass('_hover-map');
	                    persons.eq($(this).index()).add(creative).add(content.eq($(this).index() + 1)).addClass('_hover-map');
	                }, function () {
	                    if ($(this).closest('.js-facts-slider').hasClass('_animating')) return;
	                    content.eq(0).addClass('_hover-map');
	                    persons.eq($(this).index()).add(creative).add(content.eq($(this).index() + 1)).removeClass('_hover-map');
	                });
	                $('.js-facts-promo-map').imageMapResize();
	            }
	        }
	    }, {
	        key: 'inViewport',
	        value: function inViewport() {
	            if (this.root.is(':in-viewport')) {
	                var props = this.root[0].getBoundingClientRect();
	
	                if (props.top < screen.availHeight / 2 && props.bottom > screen.availHeight / 2) {
	                    $(document).trigger('counters:main_advantages_block_show');
	                    $(window).off('scroll', $.proxy(this.inViewport, this));
	                }
	            }
	        }
	    }]);
	
	    return Facts;
	}();
	
	var facts = new Facts();
	
	exports.default = facts;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	(function ($) {
	    "use strict";
	
	    // es5
	
	    var forms = $('.js-form'),
	        rules = {};
	
	    if (!forms.length) return;
	
	    forms.each(function () {
	        var form = $(this);
	
	        setupValidate(form, rules);
	    });
	
	    // Функция валидации формы
	    function setupValidate(form, rules) {
	        var inputs = $('.js-form-field', form),
	            submitButton = $('.js-form-btn', form);
	
	        submitButton.attr('disabled', !$('.js-form-btn-disabler').prop('checked'));
	
	        // Задаем маски по атрибуту words (только буквы)
	        $('[data-mask-words]', form).each(function () {
	            $(this).inputmask("Regex", {
	                regex: "^[а-яА-ЯёЁa-zA-Z -]+$",
	                placeholder: ''
	            });
	        });
	
	        // Задаем маски по атрибуту phone (телефон по маске)
	        $('[data-mask-phone]', form).each(function () {
	            $(this).inputmask({
	                mask: '8 (999) 999 - 99 - 99',
	                showMaskOnHover: false
	            });
	            rules[$(this).attr('name')] = {
	                phone: true
	            };
	        });
	
	        function getItem(element) {
	            return $(element).closest('.form-item');
	        }
	
	        var options = {
	            rules: rules,
	            ignore: [],
	            onkeyup: function onkeyup(element) {
	                getItem(element).removeClass('_invalid');
	            },
	            errorPlacement: function errorPlacement(error, element) {
	                getItem(element).find('.form-item-error').text(error.text());
	            },
	            highlight: function highlight(element, errorClass, validClass) {
	                getItem(element).addClass('_invalid');
	                getItem(element).toggleClass('_filled', $(element).is('[type="checkbox"]') ? $(element).prop('checked') : $(element).val().length > 0);
	            },
	            unhighlight: function unhighlight(element, errorClass, validClass) {
	                getItem(element).removeClass('_invalid');
	            },
	            onfocusout: function onfocusout(element) {
	                getItem(element).toggleClass('_filled', $(element).is('[type="checkbox"]') ? $(element).prop('checked') : $(element).val().length > 0);
	                $(element).valid();
	            },
	            onclick: function onclick(element) {
	                if ($(element).hasClass('js-form-btn-disabler')) {
	                    submitButton.attr('disabled', !$(element).prop('checked'));
	                }
	                getItem(element).toggleClass('_filled', $(element).prop('checked'));
	            }
	        };
	
	        inputs.each(function () {
	            getItem(this).toggleClass('_filled', $(this).is('[type="checkbox"]') ? $(this).prop('checked') : $(this).val().length > 0);
	            $(this).change(function () {
	                $(this).valid();
	            });
	            $(this).focus(function () {
	                $(this).closest('.form-item').addClass('_focus');
	                gaCounter('send', 'event', 'form', 'focus', $(this).attr('name'));
	                yaCounter.reachGoal('form_focus');
	            });
	            $(this).blur(function () {
	                $(this).closest('.form-item').removeClass('_focus');
	            });
	
	            if ($(this).is('[type="file"]')) {
	                $(this).on('input change', function () {
	
	                    //Если крепится файл, обрезаем название пути по длине
	                    if (!$(this).parents('.js-form-item').is('._invalid')) {
	                        var value = $(this).val(),
	                            arr = value.split('\\');
	
	                        //if (value.length > 30) value = '..'+value.slice(-30);
	                        if (value.length) value = arr[arr.length - 1] + '  (до 5 Мб)';
	
	                        $(this).next().text(value ? value : 'Прикрепить резюме (до 5 Мб)');
	                    }
	                });
	            }
	        });
	
	        if (form.hasClass('js-form-ajax')) {
	            options.submitHandler = function (form) {
	                var $form = $(form);
	
	                $form.ajaxSubmit({
	                    beforeSubmit: function beforeSubmit() {
	                        submitButton.attr('disabled', 'disabled');
	                    },
	                    success: function success(data) {
	                        //data = JSON.parse(data);
	                        submitButton.removeAttr('disabled');
	                        if (data.success) {
	                            var parent = $form.closest('.form-container');
	                            parent.addClass('_success');
	
	                            //setTimeout(function () {
	                            //    parent.removeClass('_success');
	                            //    $form.get(0).reset();
	                            //    parent.find('._filled').removeClass('_filled');
	                            //}, 1500);
	                            $(document).trigger('form:success', $form);
	                        } else if (data.success === false) {
	                            alert(data.message);
	                        }
	
	                        var eventLabel = $('.vacancy-promo__title').text().replace(/\r?\n/g, " ").replace(/ {2,}/g, " ");
	                        gaCounter('send', 'event', 'form', 'send', eventLabel, { dimension4: eventLabel });
	                        yaCounter.reachGoal('form_send');
	                    }
	                });
	            };
	        }
	
	        form.validate(options);
	    }
	
	    $.validator.methods.email = function (value, element) {
	        return this.optional(element) || /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zа-яёії\-0-9]+\.)+[a-zа-яёії]{2,}))$/i.test(value);
	    };
	
	    $.validator.addMethod("phone", function (value, element) {
	        return this.optional(element) || $(element).inputmask("isComplete");
	    }, "Введите корректный номер.");
	})(jQuery);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var rv = 0;
	    if (navigator.appName == 'Microsoft Internet Explorer') {
	        var ua = navigator.userAgent;
	        var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
	        if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
	    } else if (navigator.appName == 'Netscape') {
	        var _ua = navigator.userAgent;
	        var _re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
	        if (_re.exec(_ua) != null) rv = parseFloat(RegExp.$1);
	    }
	    return rv;
	}();

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Invitation = function Invitation() {
	    _classCallCheck(this, Invitation);
	
	    var onAnimate = function onAnimate() {
	        $('.vacancy-invitation:in-viewport').each(function (i, el) {
	            $(el).isInViewport({ tolerance: -275 }).each(function () {
	                $(window).off('scroll', onAnimate);
	                window.gaCounter('send', 'event', 'feedback_block', 'show', $('.vacancy-promo__title').text());
	            });
	        });
	    };
	
	    $(window).on('scroll', onAnimate);
	
	    $(document).on('ga:clientID', function (e, clientID) {
	        $('.js-form-cid').val(clientID);
	    });
	};
	
	var invitation = new Invitation();
	
	exports.default = invitation;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	    Блокировка скролла
	*/
	
	var scrollPosition = 0;
	
	App.lockScroll = {
	    lock: function lock() {
	        /**
	         * Так как страница перепрыгивает вверх,
	         * когда срабатывает overflow:hidden,
	         * принудительно сколлим её до
	         * запомненного состояния
	         */
	        scrollPosition = App.W.scrollTop();
	
	        $('html, body').addClass('_noscroll').scrollTop(scrollPosition);
	    },
	    unlock: function unlock() {
	        return $('html, body').removeClass('_noscroll').scrollTop(scrollPosition);
	    }
	};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	// Find matches
	var mql = window.matchMedia("(orientation: portrait)");
	
	// If there are matches, we're in portrait
	// if(mql.matches) {
	//     // Portrait orientation
	// } else {
	//     // Landscape orientation
	// }
	
	// Add a media query change listener
	mql.addListener(function (m) {
	    if (m.matches) {
	        // Changed to portrait
	        $(window).trigger('orientation:portrait');
	    } else {
	        // Changed to landscape
	        $(window).trigger('orientation:landscape');
	    }
	});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slider = __webpack_require__(16);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Photos = function (_Slider) {
	    _inherits(Photos, _Slider);
	
	    function Photos() {
	        _classCallCheck(this, Photos);
	
	        return _possibleConstructorReturn(this, (Photos.__proto__ || Object.getPrototypeOf(Photos)).apply(this, arguments));
	    }
	
	    _createClass(Photos, [{
	        key: 'slideFunc',
	        value: function slideFunc(slide) {
	            this.slides.removeClass('_next _prev');
	            this.root[0].offsetHeight; // задержка
	            this.current.removeClass('_active').addClass('_prev');
	            this.current = slide.addClass('_active');
	            if (this.current.next().length) {
	                this.current.next().addClass('_next');
	            } else {
	                this.slides.eq(0).addClass('_next');
	            }
	        }
	    }]);
	
	    return Photos;
	}(_slider2.default);
	
	var photos = new Photos({ selector: '.js-photos-slider' });
	
	exports.default = photos;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	// Если уже соглашались с использованием куков,
	// больше не показываем попап
	
	(function ($) {
	    var $popup = $('.js-popup-cookie');
	
	    if ($.cookie('agree_use_cookie')) {
	        $popup.addClass('_hidden');
	    }
	
	    $('.js-cookie-agree').on('click', function () {
	        $popup.addClass('_hidden');
	        $.cookie('agree_use_cookie', '1', { path: '/' });
	    });
	})(jQuery);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Popup = function () {
	    function Popup(popup) {
	        _classCallCheck(this, Popup);
	
	        this.$root = $(popup);
	        this.name = this.$root.data('name');
	        this.openedClass = 'common-popup--opened';
	        this.closeClass = 'js-common-popup-close';
	        this.contentClass = 'js-common-popup-content';
	        this.forms = $('.js-form', this.$root);
	        this.isOpen = false;
	
	        if (!this.$root.length) return [];
	
	        this.bind();
	    }
	
	    // события
	
	
	    _createClass(Popup, [{
	        key: 'bind',
	        value: function bind() {
	            var _this = this;
	
	            App.D.on('click', '[data-popup="' + this.name + '"]', function (e) {
	                e.preventDefault();
	                App.D.trigger('popup:open', {
	                    name: _this.name
	                });
	            });
	
	            this.$root.on('click', '.' + this.closeClass, function (e) {
	                e.preventDefault();
	                //this.close();
	                $(e.currentTarget).trigger('popup:close');
	            });
	
	            // закрываем попап по клику на поля
	            // this.$root.on('click', (e) => {
	            //     if (e.target == this.$root[0]) {
	            //         this.close();
	            //     }
	            // });
	
	            // закрываем попап по всплытию события popup:close
	            this.$root.on('popup:close', function () {
	                _this.close();
	            });
	
	            // Закрыть попап клавишей Escape
	            App.W.on('keydown.popup', function (e) {
	                if (_this.isOpen && e.keyCode == 27) {
	                    _this.close();
	                }
	            });
	
	            // открываем попап
	            App.D.on('popup:open', function (e, data) {
	                if (data.name == _this.name) {
	                    if (data.content) {
	                        $('.' + _this.contentClass, _this.$root).html(data.content);
	                    }
	
	                    _this.resetForms();
	                    _this.open();
	                }
	            });
	        }
	    }, {
	        key: 'open',
	        value: function open() {
	            var _this2 = this;
	
	            this.isOpen = true;
	            this.$root.addClass(this.openedClass);
	            setTimeout(function () {
	                _this2.$root.trigger('popup:opened');
	            }, 300);
	            App.lockScroll.lock();
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            var _this3 = this;
	
	            this.isOpen = false;
	            this.$root.removeClass(this.openedClass);
	            setTimeout(function () {
	                _this3.$root.trigger('popup:closed');
	                _this3.resetForms();
	            }, 300);
	            App.lockScroll.unlock();
	        }
	    }, {
	        key: 'resetForms',
	        value: function resetForms() {
	            // ресет success формы
	            this.forms.each(function (i, form) {
	                form.reset();
	                $(form).parent().removeClass('_success');
	                $(form).find('.js-submit').removeAttr('disabled');
	            });
	        }
	    }]);
	
	    return Popup;
	}();
	
	exports.default = Popup;
	
	
	$('.js-common-popup').each(function () {
	    new Popup(this);
	});
	
	// раскрываем сразу попап по хэшу
	if (location.hash) {
	    $('[data-popup-hash]').each(function () {
	        if ($(this).data('popup-hash') == location.hash.slice(1)) {
	            App.D.trigger('popup:open', {
	                name: $(this).data('name')
	            });
	        }
	    });
	}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Projects = function () {
	    function Projects() {
	        _classCallCheck(this, Projects);
	
	        this.root = $('.js-projects-slider');
	        this.slides = $('.js-projects-slider-item', this.root);
	        this.pager = $('.js-projects-slider-pager', this.root);
	        this.next = $('.js-projects-slider-next', this.root);
	        this.prev = $('.js-projects-slider-prev', this.root);
	        this.current = this.slides.filter('._active').length ? this.slides.filter('._active') : this.slides.eq(0);
	        this.animating = false;
	        this.duration = 800;
	
	        this.init();
	    }
	
	    _createClass(Projects, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            this.root.addClass('_dir-prev');
	            this.current.next().addClass('_prev');
	
	            this.slides.each(function (i, el) {
	                _this.pager.append('<i' + (i == _this.current.index() ? ' class="_active"' : '') + '>');
	            });
	
	            if (this.root.data('preRender')) {
	                this.root.on('preRenderEnd', function () {
	                    _this.current.addClass('_active');
	                    _this.bind();
	                });
	            } else {
	                this.current.addClass('_active');
	                this.bind();
	            }
	        }
	    }, {
	        key: 'bind',
	        value: function bind() {
	            var _this2 = this;
	
	            this.root.addClass('_projects-slider-rendered');
	            if (device.mobile() || device.tablet()) {
	                this.root.hammer().on('swipeleft', function (ev) {
	                    _this2.next.click();
	                });
	
	                this.root.hammer().on('swiperight', function (ev) {
	                    _this2.prev.click();
	                });
	            }
	
	            this.next.on('click', function (e) {
	                _this2.slideTo(_this2.current.next().length ? _this2.current.next() : _this2.slides.eq(0));
	            });
	
	            this.prev.on('click', function (e) {
	                _this2.slideTo(_this2.current.prev().length ? _this2.current.prev() : _this2.slides.eq(_this2.slides.length - 1));
	            });
	
	            this.pager.find('i').on('click', function (e) {
	                _this2.slideTo(_this2.slides.eq($(e.currentTarget).index()));
	            });
	        }
	    }, {
	        key: 'slideTo',
	        value: function slideTo(slide) {
	            var _this3 = this;
	
	            if (this.animating || this.current[0] == slide[0]) return;
	            this.animating = true;
	            this.root.removeClass('_dir-prev _dir-next');
	            this.slides.removeClass('_prev');
	            if (this.current.index() - slide.index() == this.slides.length - 1 || this.current.index() - slide.index() != -(this.slides.length - 1) && this.current.index() < slide.index()) {
	                this.root.addClass('_dir-next');
	            } else {
	                this.root.addClass('_dir-prev');
	            }
	            this.root[0].offsetHeight; // задержка
	            this.current.removeClass('_active').addClass('_prev');
	            this.current = slide.addClass('_active');
	            this.pager.find('i').removeClass('_active').eq(this.current.index()).addClass('_active');
	            setTimeout(function () {
	                _this3.animating = false;
	            }, this.duration);
	        }
	    }]);
	
	    return Projects;
	}();
	
	var projects = new Projects();
	
	exports.default = projects;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Share = function () {
	    function Share() {
	        _classCallCheck(this, Share);
	
	        this.url = $('meta[property="og:url"]').attr('content');
	        this.title = $('meta[property="og:title"]').attr('content');
	        this.image = $('meta[property="og:image"]').attr('content');
	        this.text = $('meta[property="og:description"]').attr('content');
	    }
	
	    _createClass(Share, [{
	        key: 'vk',
	        value: function vk() {
	            var url = 'http://vkontakte.ru/share.php?';
	
	            url += 'url=' + encodeURIComponent(this.url);
	            url += '&title=' + encodeURIComponent(this.title);
	            url += '&description=' + encodeURIComponent(this.text);
	            url += '&image=' + encodeURIComponent(this.image);
	            url += '&noparse=true';
	
	            this.popup(url);
	        }
	    }, {
	        key: 'ok',
	        value: function ok() {
	            var url = 'http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1';
	
	            url += '&st.comments=' + encodeURIComponent(this.text);
	            url += '&st._surl=' + encodeURIComponent(this.url);
	
	            this.popup(url);
	        }
	    }, {
	        key: 'fb',
	        value: function fb() {
	            var url = 'http://www.facebook.com/sharer.php?';
	
	            url += 'u=' + encodeURIComponent(this.url);
	
	            this.popup(url);
	        }
	    }, {
	        key: 'tw',
	        value: function tw() {
	            var url = 'http://twitter.com/share?';
	
	            url += 'text=' + encodeURIComponent(this.title);
	            url += '&url=' + encodeURIComponent(this.url);
	            url += '&counturl=' + encodeURIComponent(this.url);
	
	            this.popup(url);
	        }
	    }, {
	        key: 'mr',
	        value: function mr() {
	            var url = 'http://connect.mail.ru/share?';
	
	            url += 'url=' + encodeURIComponent(this.url);
	            url += '&title=' + encodeURIComponent(this.title);
	            url += '&description=' + encodeURIComponent(this.text);
	            url += '&imageurl=' + encodeURIComponent(this.image);
	
	            this.popup(url);
	        }
	    }, {
	        key: 'popup',
	        value: function popup(url) {
	            window.open(url, '', 'toolbar=0,status=0,width=626,height=436');
	        }
	    }]);
	
	    return Share;
	}();
	
	var share = new Share();
	
	exports.default = share;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Slider = function () {
	    function Slider(opts) {
	        _classCallCheck(this, Slider);
	
	        this.opts = {
	            selector: '.js-slider'
	        };
	        Object.assign(this.opts, opts);
	        this.root = $(this.opts.selector);
	        if (!this.root.length) return [];
	        this.wrap = $('.js-slider-wrap', this.root);
	        this.slides = $('.js-slider-item', this.root);
	        this.pager = $('.js-slider-pager', this.root);
	        this.next = $('.js-slider-next', this.root);
	        this.prev = $('.js-slider-prev', this.root);
	        this.current = this.slides.filter('._active').length ? this.slides.filter('._active') : this.slides.eq(0).addClass('_active');
	        this.animating = false;
	        this.duration = 800;
	
	        this.init();
	        this.bind();
	    }
	
	    _createClass(Slider, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            this.root.addClass('_dir-prev');
	            this.current.next().addClass('_next');
	            this.slides.last().addClass('_prev');
	
	            this.slides.each(function (i, el) {
	                _this.pager.append('<i' + (i == _this.current.index() ? ' class="_active"' : '') + '>');
	            });
	
	            if (device.mobile() || device.tablet()) {
	                this.root.hammer().on('swipeleft', function (ev) {
	                    //console.log('swipeleft');
	                    _this.next.click();
	                });
	
	                this.root.hammer().on('swiperight', function (ev) {
	                    //console.log('swiperight');
	                    _this.prev.click();
	                });
	            }
	        }
	    }, {
	        key: 'bind',
	        value: function bind() {
	            var _this2 = this;
	
	            this.next.on('click', function (e) {
	                _this2.slideTo(_this2.current.next().length ? _this2.current.next() : _this2.slides.eq(0));
	            });
	
	            this.prev.on('click', function (e) {
	                _this2.slideTo(_this2.current.prev().length ? _this2.current.prev() : _this2.slides.eq(_this2.slides.length - 1));
	            });
	
	            this.pager.find('i').on('click', function (e) {
	                _this2.slideTo(_this2.slides.eq($(e.currentTarget).index()));
	            });
	        }
	    }, {
	        key: 'updateDirection',
	        value: function updateDirection(slide) {
	            this.root.removeClass('_dir-prev _dir-next');
	            if (this.current.index() - slide.index() == this.slides.length - 1 || this.current.index() - slide.index() != -(this.slides.length - 1) && this.current.index() < slide.index()) {
	                this.root.addClass('_dir-next');
	            } else {
	                this.root.addClass('_dir-prev');
	            }
	        }
	    }, {
	        key: 'updatePager',
	        value: function updatePager() {
	            this.pager.find('i').removeClass('_active').eq(this.current.index()).addClass('_active');
	        }
	    }, {
	        key: 'slideTo',
	        value: function slideTo(slide) {
	            var _this3 = this;
	
	            if (this.animating || this.current[0] == slide[0]) return;
	            this.animating = true;
	            this.updateDirection(slide);
	            this.slideFunc(slide);
	            // this.slides.removeClass('_next _prev');
	            // this.root[0].offsetHeight; // задержка
	            // this.current.removeClass('_active').addClass('_prev');
	            // this.current = slide.addClass('_active');
	            this.updatePager();
	            setTimeout(function () {
	                _this3.animating = false;
	                _this3.updatePager();
	            }, this.duration);
	        }
	    }, {
	        key: 'slideFunc',
	        value: function slideFunc(slide) {
	            this.slides.removeClass('_next _prev');
	            this.root[0].offsetHeight; // задержка
	            this.current.removeClass('_active').addClass('_prev');
	            this.current = slide.addClass('_active');
	        }
	    }]);
	
	    return Slider;
	}();
	
	exports.default = Slider;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ie = __webpack_require__(7);
	
	var _ie2 = _interopRequireDefault(_ie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Team = function () {
	    function Team() {
	        _classCallCheck(this, Team);
	
	        this.root = $('.js-team-slider');
	        this.slides = $('.js-team-slider-item', this.root);
	        this.slidesBg = $('.js-team-slider-bg', this.root);
	        this.bullets = $('.js-team-slider-bullets', this.root);
	        this.next = $('.js-team-slider-next', this.root);
	        this.prev = $('.js-team-slider-prev', this.root);
	        this.promoButton = $('.js-promo-next', this.root);
	        this.mapLinks = $('.js-team-promo-map area', this.root);
	        this.currentSlide = this.slides.filter('._active').length ? this.slides.filter('._active') : this.slides.eq(0);
	        this.animating = false;
	        this.duration = 800;
	
	        this.init();
	    }
	
	    _createClass(Team, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            this.root.addClass('_dir-prev');
	            this.currentSlide.next().addClass('_prev');
	
	            this.slides.each(function (i, el) {
	                _this.bullets.append('<i' + (i == _this.currentSlide.index() ? ' class="_active"' : '') + '>');
	                $(el).find('.js-team-slider-number').text($(el).index() > 9 ? $(el).index() : '0' + $(el).index());
	                $(el).find('.js-team-slider-total').text(_this.slides.length > 9 ? _this.slides.length - 1 : '0' + (_this.slides.length - 1));
	            });
	
	            if (this.root.data('preRender')) {
	                this.root.on('preRenderEnd', function () {
	                    setTimeout(function () {
	                        _this.currentSlide.addClass('_active');
	                        _this.initFirstSlide();
	                        _this.bind();
	                    }, 30);
	                });
	            } else {
	                this.currentSlide.addClass('_active');
	                this.initFirstSlide();
	                this.bind();
	            }
	
	            // переход на hash авигацию
	            if (_ie2.default && _ie2.default <= 11) {
	                window.addEventListener("hashchange", $.proxy(this.onPopstate, this), false); // IE11
	            } else {
	                window.addEventListener("popstate", $.proxy(this.onPopstate, this), false);
	            }
	            this.onPopstate();
	        }
	    }, {
	        key: 'bind',
	        value: function bind() {
	            var _this2 = this;
	
	            if (device.mobile() || device.tablet()) {
	                this.root.hammer().on('swipeleft', function (ev) {
	                    _this2.next.click();
	                });
	
	                this.root.hammer().on('swiperight', function (ev) {
	                    _this2.prev.click();
	                });
	            }
	
	            if (device.desktop()) {
	                this.mapLinks.on('click', function (e) {
	                    // e.preventDefault();
	                    // if (this.animating) return;
	                    // setTimeout(() => {
	                    //     this.slideTo(this.slides.eq($(e.currentTarget).data('slide')));
	                    // }, (device.mobile() || device.tablet()) ? this.duration * 2 : 0);
	
	                    // переход на hash авигацию
	                    e.preventDefault();
	                    if (_this2.animating) return;
	                    window.location.hash = '#' + $('.js-team-hash-nav [data-slide="' + $(e.currentTarget).data('slide') + '"]').attr('name');
	                });
	            }
	
	            this.promoButton.on('click', function () {
	                _this2.slideTo(_this2.slides.eq(1));
	            });
	
	            this.next.on('click', function (e) {
	                //this.slideTo(this.currentSlide.next().length ? this.currentSlide.next() : this.slides.eq(0));
	
	                // переход на hash авигацию
	                var slide = _this2.currentSlide.next().length ? _this2.currentSlide.next() : _this2.slides.eq(0);
	                if (slide.data('slide') == 0) {
	                    window.location.hash = '#team';
	                } else {
	                    window.location.hash = '#' + $('.js-team-hash-nav [data-slide="' + slide.data('slide') + '"]').attr('name');
	                }
	            });
	
	            this.prev.on('click', function (e) {
	                //this.slideTo(this.currentSlide.prev().length ? this.currentSlide.prev() : this.slides.eq(this.slides.length - 1));
	
	                // переход на hash авигацию
	                var slide = _this2.currentSlide.prev().length ? _this2.currentSlide.prev() : _this2.slides.eq(_this2.slides.length - 1);
	                if (slide.data('slide') == 0) {
	                    window.location.hash = '#team';
	                } else {
	                    window.location.hash = '#' + $('.js-team-hash-nav [data-slide="' + slide.data('slide') + '"]').attr('name');
	                }
	            });
	
	            this.bullets.find('i').on('click', function (e) {
	                //this.slideTo(this.slides.eq($(e.currentTarget).index()));
	
	                // переход на hash авигацию
	                var slide = _this2.slides.eq($(e.currentTarget).index());
	                if (slide.data('slide') == 0) {
	                    window.location.hash = '#team';
	                } else {
	                    window.location.hash = '#' + $('.js-team-hash-nav [data-slide="' + slide.data('slide') + '"]').attr('name');
	                }
	            });
	        }
	
	        // переход на hash авигацию
	
	    }, {
	        key: 'onPopstate',
	        value: function onPopstate() {
	            var _this3 = this;
	
	            var slide = $('.js-team-hash-nav [name="' + window.location.hash.substr(1) + '"]').data('slide') || (window.location.hash == '#team' ? 0 : undefined);
	
	            if (slide != undefined && !this.animating) {
	                if (slide != 0) {
	                    this.slides.eq(0).css('visibility', 'hidden');
	                    setTimeout(function () {
	                        _this3.slides.eq(0).css('visibility', 'visible');
	                    }, 1000);
	                }
	                setTimeout(function () {
	                    _this3.slideTo(_this3.slides.eq(slide), 0);
	                }, device.mobile() || device.tablet() ? this.duration * 2 : 0);
	            }
	        }
	    }, {
	        key: 'slideTo',
	        value: function slideTo(slide, duration) {
	            var _this4 = this;
	
	            if (this.animating || this.currentSlide[0] == slide[0]) return;
	            this.animating = true;
	            this.root.addClass('_animating');
	            this.root.removeClass('_dir-prev _dir-next');
	            this.slides.removeClass('_prev');
	            if (this.currentSlide.index() - slide.index() == this.slides.length - 1 || this.currentSlide.index() - slide.index() != -(this.slides.length - 1) && this.currentSlide.index() < slide.index()) {
	                this.root.addClass('_dir-next');
	            } else {
	                this.root.addClass('_dir-prev');
	            }
	            this.currentSlide.addClass('_leaving');
	            this.bullets.find('i').removeClass('_active').eq(slide.index()).addClass('_active');
	
	            setTimeout(function () {
	                //this.animating = false;
	
	
	                _this4.currentSlide.removeClass('_active').addClass('_prev');
	                _this4.currentSlide = slide.addClass('_active');
	                _this4.root.attr('data-active', _this4.currentSlide.index());
	                _this4.slidesBg.css({
	                    color: _this4.currentSlide.data('colors').split(',')[0],
	                    fill: _this4.currentSlide.data('colors').split(',')[1]
	                });
	                _this4.currentSlide.css({
	                    fill: _this4.currentSlide.data('colors').split(',')[0]
	                });
	                if (_this4.currentSlide.index() === 0) {
	                    _this4.currentSlide.find('._hover-map').removeClass('_hover-map');
	                    _this4.currentSlide.find('.team-promo__content-item').eq(0).addClass('_hover-map');
	                }
	                _this4.root[0].offsetHeight; // задержка
	                _this4.slides.removeClass('_leaving');
	
	                setTimeout(function () {
	                    _this4.animating = false;
	                    _this4.root.removeClass('_animating');
	                }, _this4.duration);
	            }, duration != undefined ? duration : this.duration);
	        }
	    }, {
	        key: 'initFirstSlide',
	        value: function initFirstSlide() {
	            //let teamPromo = $('.js-team-promo');
	            var creative = $('.js-team-promo-creative');
	            var persons = $('.js-team-promo-person');
	            var content = $('.js-team-promo-content').children();
	
	            if (device.desktop()) {
	                $('.js-team-promo-map area').hover(function () {
	                    if ($(this).closest('.js-team-slider').hasClass('_animating')) return;
	                    content.eq(0).removeClass('_hover-map');
	                    persons.eq($(this).index()).add(creative).add(content.eq($(this).index() + 1)).addClass('_hover-map');
	                }, function () {
	                    if ($(this).closest('.js-team-slider').hasClass('_animating')) return;
	                    content.eq(0).addClass('_hover-map');
	                    persons.eq($(this).index()).add(creative).add(content.eq($(this).index() + 1)).removeClass('_hover-map');
	                });
	                $('.js-team-promo-map').imageMapResize();
	            }
	        }
	    }]);
	
	    return Team;
	}();
	
	var team = new Team();
	
	exports.default = team;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.randomInteger = randomInteger;
	
	// рандомное число в интервале от min до max включительно
	function randomInteger(min, max) {
	    // случайное число от min до (max+1)
	    var rand = min + Math.random() * (max + 1 - min);
	    return Math.floor(rand);
	}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Vacancies = function Vacancies() {
	    _classCallCheck(this, Vacancies);
	
	    var $vacancies = $('.js-section.vacancies');
	
	    $(window).on('scroll', vacanciesInViewport);
	
	    function vacanciesInViewport() {
	        if ($vacancies.is(':in-viewport')) {
	            var props = $vacancies[0].getBoundingClientRect();
	
	            if (props.top < screen.availHeight / 2 && props.bottom > screen.availHeight / 2) {
	                $(document).trigger('counters:main_vacancies_block_show');
	                $(window).off('scroll', vacanciesInViewport);
	            }
	        }
	    }
	
	    $('.vacancies__item').on('click', function () {
	        if (!$(this).find('img[src$="vacancy_closed.png"]').length) {
	            $(document).trigger('counters:main_vacancies_block_click', $(this).find('.vacancies__card-title').text());
	        }
	    });
	
	    $('.js-vacancy-invitation-form-close').click(function () {
	        $('.js-vacancy-invitation-form').slideUp();
	    });
	
	    $('.js-vacancy-invitation-form-open').click(function () {
	        $('.js-vacancy-invitation-form').slideDown();
	    });
	};
	
	var invitation = new Vacancies();
	
	exports.default = invitation;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Vacancy = function Vacancy() {
	    _classCallCheck(this, Vacancy);
	
	    var vacancyData = $('.js-vacancy-data').data('source'),
	        $hero = $('.vacancy-promo__bg-hero');
	
	    if (vacancyData) {
	        if (vacancyData.style) {
	            $('.vacancy-promo__bg').css({
	                'background-color': vacancyData.style['background-color'],
	                'fill': vacancyData.style['fill']
	            });
	        }
	        if (vacancyData.image) {
	            $hero.html('<img class="_animated" src="' + vacancyData.image + '" alt="">');
	            requestAnimationFrame(function () {
	                $hero.find('._animated').removeClass('_animated');
	            });
	        }
	        if (vacancyData.form) {
	            for (var key in vacancyData.form) {
	                $('[name="' + key + '"]').val(vacancyData.form[key]);
	            }
	        }
	    }
	};
	
	var vacancy = new Vacancy();
	
	exports.default = vacancy;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js